import { assignController } from '../api/element-manipulation'


assignController('clearAlert', (element) => {
  const { userId, notificationId: postId } = element.dataset

  const doSubmit = async () => {
    const formData = new window.FormData()

    formData.append('user_id', userId)
    formData.append('post_id', postId)
    try {
      // 1. Pause execution until the fetch promise resolves
      const response = await fetch('/wp-json/customweb/v1/clear_notification_alert', {
        method: 'POST',
        headers: {
          'X-WP-Nonce': window.data.rest.nonce,
        },
        body: formData,
      });
      // 2. Check if the request was successful (status 200-299)
      if (!response.ok) {
        console.log('HTTP error! status:', response);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 3. Parse the response body as JSON (also returns a promise)
      const data = await response.json();
      if (data.code === '200') {
        // Handle success case
        console.log('Succes reload page or update state to reflect changes');
        // For example, you might want to reload the page or update the UI to reflect the changes
        window.location.reload();
      } else {
        // Handle error case based on response data
        console.log('Error in response:', data);
      }
    } catch (error) {
      // 4. Catch network errors or errors thrown above
      console.log('There was an error fetching the data:', error);
    }
  }

  element.addEventListener('click', (e) => {
    console.log('remove users notification alert', e);
    doSubmit();
  })
})
